import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { FlopppyButton } from "../../../common/ButtonWithLoading";
import { DatePicker } from "antd";
import moment from "moment";
import { SelectForm } from "../../../common/Buttons";
import { getDateFormat } from "../../../../helpers/Utils";

function ServiceSupplier({
  supplySupplier,
  supplyItem,
  orderId,
  postOrderRow,
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [variables, setVariables] = useState({
    date: "",
    product_code: "",
    supplier_id: undefined,
    supplier_selected: undefined,
    presta_service: false,
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (supplyItem.length > 0) {
      handleSupplyBlock("supplier_selected", supplyItem[0].value);
    }
  }, [supplyItem]);

  const createNewOrderRow = () => {
    const { date, supplier_id, supplier_selected, presta_service } = variables;
    let errors = {};
    if (!supplier_id || !supplier_selected) {
      errors.service = "Select a service.";
    }
    if (!date) {
      errors.date = "Select a date..";
    }
    if (Object.entries(errors).length > 0) {
      return setErrors(errors);
    }
    setLoading(true);
    const resVariables = {
      date,
      amount: 1,
    };
    if (presta_service) {
      resVariables.presta_service_id = supplier_id.replace("presta_", "");
    } else {
      resVariables.supplier_id = supplier_id;
    }

    dispatch(postOrderRow(resVariables, orderId, supplier_selected)).then(
      (res) => {
        if (res.success) {
          setVariables((prev) => ({
            ...prev,
            date: "",
            supplier_id,
            presta_service: false,
          }));
          setLoading(false);
          setErrors({});
        } else {
          setLoading(false);
          setErrors({ error: "Error occurred" });
        }
      }
    );
  };
  const handleSupplyBlock = (name, value) => {
    setVariables({
      ...variables,
      [name]: value,
    });
  };

  const { date, supplier_id } = variables;

  return (
    <div className="col-12 bg-silver">
      <div className="d-flex pt-3">
        <span className="pr-1" style={{ width: "50%" }}>
          <SelectForm
            options={supplySupplier}
            onlyPlaceholder="Servisai"
            name="supplier_id"
            value={supplier_id}
            onChange={(e) => {
              let value = e;
              setVariables((prev) => ({
                ...prev,
                supplier_id: value,
                presta_service:
                  typeof value == "string" && value.includes("presta_"),
              }));
            }}
            error={errors.service}
          />
        </span>
        <span className="pl-1" style={{ width: "50%" }}>
          <DatePicker
            className={errors.date ? "error_border" : ""}
            style={{ width: "100%" }}
            placeholder="Data"
            disabledDate={(d) =>
              !d || d.isBefore(moment().format("YYYY-MM-DD"))
            }
            value={getDateFormat(date)}
            onChange={(e, arg) => handleSupplyBlock("date", arg)}
            error={errors.date}
          />
          {errors.date && <div className="text-danger">{errors.date}</div>}
        </span>
      </div>
      <div className="d-flex justify-content-between">
        <span style={{ width: "20%" }}>
          {errors.error && <div className="text-danger">{errors.error}</div>}
        </span>

        <span className="pl-1 pt-2 pb-3 text-right" style={{ width: "25%" }}>
          <FlopppyButton
            loading={loading}
            onClick={() => createNewOrderRow()}
          />
        </span>
      </div>
    </div>
  );
}

export default ServiceSupplier;
